import { COUNTRY_CODE, STATES } from '@shared/common';
import { Environment } from '@shared/environment';

export const environment: Environment = {
	iosLink: 'https://itunes.apple.com/app/1453830595',
	androidLink:
		'https://play.google.com/store/apps/details?id=com.restoreunited',
	platform: 'web',
	production: false,
	domain: 'restoreunited.com',
	company: 'RestoreUnited',
	companyCode: 'btr',
	env: {
		// apiUrl: 'http://stage.eba-zetfzkqa.us-east-2.elasticbeanstalk.com',
		apiUrl: '', // The URL above is the stage URL, but we are going to use reverse proxy in Cloudfront
		baseUrl: 'https://restoreunited.com',
		// chatSignalr: 'http://stage.eba-zetfzkqa.us-east-2.elasticbeanstalk.com',
		chatSignalr: '/messenger',

		googleToken: [
			'67273863217-mh1v5sd00kuga72dt4g9etlvvrt0trfp',
			'apps.googleusercontent.com',
		].join('.'),
	},
	firebase: {
		apiKey: 'AIzaSyBhTl5D6W-BAyCWqAzQ3Zy5JwjxpsW_Kuw',
		authDomain: 'restoreunited.firebaseapp.com',
		databaseURL: 'https://restoreunited.firebaseio.com',
		projectId: 'restoreunited',
		storageBucket: 'restoreunited.appspot.com',
		messagingSenderId: '67273863217',
	},
	facebook: {
		appId: '328628611172065',
		cookie: true,
		xfbml: true,
		version: 'v3.2',
	},
	states: STATES,
	countryCode: COUNTRY_CODE,
	region: 'US',
	googleAPIKey: 'AIzaSyBnH1cDnxWfNIpX6RYDUYw8S8sVg1PNo3c',
	googleMapsId: 'd7e860b513ed6023e5e300eb',
	syncfusionLicense:
		'Ngo9BigBOggjHTQxAR8/V1JHaF5cWWdCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWXtcd3ZURWdeVUZyXUVWYEo=',
};
